
import {
  FETCH_DISTRICTS_REQUEST,
  FETCH_DISTRICTS_SUCCESS,
  FETCH_DISTRICTS_FAILURE,
  CREATE_DISTRICT_REQUEST,
  CREATE_DISTRICT_SUCCESS,
  CREATE_DISTRICT_FAILURE,
} from "../actions/districtsActions";

const initialState = {
  districts: [],
  loading: false,
  error: null,
  createStatus: null, // 'success', 'failure', or null
  createMessage: null, // success or error message
};

const districtsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DISTRICTS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DISTRICTS_SUCCESS:
      return { ...state, loading: false, districts: action.payload };

    case FETCH_DISTRICTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_DISTRICT_REQUEST:
      return { ...state, createStatus: null, createMessage: null };

    case CREATE_DISTRICT_SUCCESS:
      return {
        ...state,
        createStatus: "success",
        createMessage: "District created successfully!",
      };

    case CREATE_DISTRICT_FAILURE:
      return {
        ...state,
        createStatus: "failure",
        createMessage: action.payload, // e.g. "District already exists in this state"
      };

    default:
      return state;
  }
};

export default districtsReducer;
